import { Link, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Breadcrumb, Dropdown } from 'react-bootstrap';
import { getPathCrumbs } from './BreadcrumbsData';


var compFullWidth = 0;
var full = 0;
function Breadcrumbs ({ path, customCrumb, customPrevCrumb }) {

  
    const [crumbs, setCrumbs] = useState(getPathCrumbs(path,customPrevCrumb));
   
    const breadRef = useRef(null);
    const breadConRef = useRef(null);
    const sizeRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);

    
    const getCurrentPageCrumb = (crumbVal) => {
        if(customCrumb!=null){
            if(customCrumb?.value!=null){
                if(customCrumb?.replace==true){
                    return customCrumb.value;
                }
                else{
                    return crumbVal + "" + customCrumb.value;
                }
            }
        }
        return crumbVal;
    }
    
    const isOverflowWindow = () => {
        if(window.innerWidth < full){
            setIsOverflow(true);
        }
        else{
            setIsOverflow(false);
        }
    }

    useEffect(() => {
        var c = getPathCrumbs(path,customPrevCrumb);

        // if(prevCrumb!=null){
        //     c.push({
        //         name: customPrevCrumb.value,
        //         path: customPrevCrumb.path,
        //         state: customPrevCrumb.state,
        //     })
        // }
        //console.log(c);
        setCrumbs(c);
        
        isOverflowWindow();
    }, [path,customPrevCrumb])

    function handleResize (ev) {
        isOverflowWindow();
    }

    useEffect(() => {
        
        isOverflowWindow();
        window.addEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        full = sizeRef.current.offsetWidth + 16;
        const w = breadRef.current.offsetWidth;
        compFullWidth = (w)+16;    
        isOverflowWindow();
    }, [crumbs]);


    return (
        //w-xs-fit-content
            crumbs != null
            ?
                <div className="breadcrumb-container" ref={breadConRef} >
                    <Breadcrumb ref={breadRef} className=" flex-nowrap p-0">
                        {
                            crumbs.length >= 3
                                ?
                                    <>
                                        <Breadcrumb.Item
                                            linkAs={Link}
                                            linkProps={{ 
                                                to: crumbs[0].path,
                                                state: crumbs[0].state
                                             }}

                                        >
                                            {crumbs[0].name}
                                        </Breadcrumb.Item>
                                        <>
                                            {   /**TODO: Comment below to reflect the design update: no wrap, no ellipsis */
                                                isOverflow == false
                                                ?
                                                    crumbs.map((crumb, index) => {
                                                        if (index == 0 || index == (crumbs.length - 1)) {
                                                            return (
                                                                null
                                                            );
                                                        }
                                                        else {
                                                            return (
                                                                <Breadcrumb.Item
                                                                    linkAs={Link}
                                                                    linkProps={{ 
                                                                        to: crumb.path,
                                                                        state:crumb.state 
                                                                     }}

                                                                >
                                                                    {crumb.name}
                                                                </Breadcrumb.Item>
                                                            );
                                                        }

                                                    })
                                                /**TODO: Comment below to reflect the design update: no wrap, no ellipsis */
                                                :
                                                    <Breadcrumb.Item
                                                        linkAs={Dropdown}
                                                        linkProps={{
                                                            variant: 'clear',
                                                            className: "p-0"
                                                        }}
                                                        className="breadcrumb-dropdown-item"
                                                    >
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="" id="dropdown-basic" className="px-1 py-0">
                                                                ...
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu className=" w-sm-fit-content">
                                                                <div className="dropdown-breadcrumbs">
                                                                    {
                                                                        crumbs.map((crumb, index) => {
                                                                            if (index == 0 || index == (crumbs.length - 1)) {
                                                                                return (
                                                                                    null
                                                                                );
                                                                            }
                                                                            else {
                                                                                return (
                                                                                    <Dropdown.Item as={Link} to={crumb.path} state={crumb.state} >{crumb.name}</Dropdown.Item>
                                                                                );
                                                                            }

                                                                        })
                                                                    }
                                                                </div>
                                                            </Dropdown.Menu>
                                                        </Dropdown>

                                                    </Breadcrumb.Item>
                                            }
                                        </>
                                        
                                        <Breadcrumb.Item active  className={isOverflow == true ? "overflow-active " : ""}>
                                            <span >{getCurrentPageCrumb(crumbs[crumbs.length - 1].name)}</span>
                                        </Breadcrumb.Item>

                                    </>
                                :
                                    crumbs.map((crumb, index) => {
                                        //console.log(crumb);

                                        if (index == crumbs.length - 1) {
                                            return (
                                                
                                                <Breadcrumb.Item active >
                                                    <span >{getCurrentPageCrumb(crumb.name)}</span>
                                                </Breadcrumb.Item>
                                                
                                                
                                            );
                                        }
                                        // else if(crumbs.length-2 >= 0 && index == crumbs.length - 2){
                                        //     return (
                                               
                                        //     );
                                        // }
                                        else {
                                            if (index == 0) {
                                                return (
                                                    <Breadcrumb.Item
                                                        linkAs={Link}
                                                        linkProps={{ 
                                                            to: crumb.path,
                                                            state:crumb.state 
                                                        }}
                                                        className=""
                                                    >
                                                        {crumb.name}
                                                    </Breadcrumb.Item>
                                                );
                                            }
                                            else {
                                                return (
                                                    <Breadcrumb.Item
                                                        linkAs={Link}
                                                        linkProps={{ 
                                                            to: crumb.path,
                                                            state:crumb.state
                                                        }}
                                                        className=""
                                                    >
                                                        {crumb.name}
                                                    </Breadcrumb.Item>
                                                );
                                            }

                                        }
                                    })
                        }
                    </Breadcrumb>
                    <Breadcrumb id={"breadcrumb-size-ref"} className="w-xs-fit-content flex-nowrap p-0 overflow-clip" ref={sizeRef}>
                        {
                            crumbs.map((crumb, index) => {
                                //console.log(crumb);

                                if (index == crumbs.length - 1) {
                                    return (
                                        <Breadcrumb.Item active >
                                            <span >{getCurrentPageCrumb(crumb.name)}</span>
                                        </Breadcrumb.Item>
                                    );
                                }
                                else {
                                    if (index == 0) {
                                        return (
                                            <Breadcrumb.Item
                                                linkAs={Link}
                                                linkProps={{ 
                                                    to: crumb.path,
                                                    state:crumb.state
                                                 }}
                                                className=""
                                            >
                                                {crumb.name}
                                            </Breadcrumb.Item>
                                        );
                                    }
                                    else {
                                        return (
                                            <Breadcrumb.Item
                                                linkAs={Link}
                                                linkProps={{ 
                                                    to: crumb.path,
                                                    state:crumb.state
                                                }}
                                                className=""
                                            >
                                                {crumb.name}
                                            </Breadcrumb.Item>
                                        );
                                    }

                                }
                            })
                        }
                    </Breadcrumb>
                    
                </div>
            :   null
                /**TODO: Comment below to reflect the design update: no wrap, no ellipsis*/
                // crumbs != null
                //     ?
                //     <div className="breadcrumb-container" >
                //         <Breadcrumb ref={breadRef} className="w-xs-fit-content flex-nowrap p-0">
                //             {
                //                 crumbs.length >= 3
                //                     ?
                //                     <>
                //                         <Breadcrumb.Item
                //                             linkAs={Link}
                //                             linkProps={{ to: crumbs[0].path }}

                //                         >
                //                             {crumbs[0].name}
                //                         </Breadcrumb.Item>
                //                         <>
                //                             {
                //                                 isOverflow == false
                //                                     ?
                //                                     crumbs.map((crumb, index) => {
                //                                         if (index == 0 || index == (crumbs.length - 1)) {
                //                                             return (
                //                                                 null
                //                                             );
                //                                         }
                //                                         else {
                //                                             return (
                //                                                 <Breadcrumb.Item
                //                                                     linkAs={Link}
                //                                                     linkProps={{ to: crumb.path }}

                //                                                 >
                //                                                     {crumb.name}
                //                                                 </Breadcrumb.Item>
                //                                             );
                //                                         }

                //                                     })
                //                                     :

                //                                     <Breadcrumb.Item
                //                                         linkAs={Dropdown}
                //                                         linkProps={{
                //                                             variant: 'clear',
                //                                             className: "p-0"
                //                                         }}
                //                                         className="breadcrumb-dropdown-item"
                //                                     >
                //                                         <Dropdown>
                //                                             <Dropdown.Toggle variant="" id="dropdown-basic" className="p-1">
                //                                                 ...
                //                                             </Dropdown.Toggle>

                //                                             <Dropdown.Menu className=" w-sm-fit-content">
                //                                                 <div className="dropdown-breadcrumbs">
                //                                                     {
                //                                                         crumbs.map((crumb, index) => {
                //                                                             if (index == 0 || index == (crumbs.length - 1)) {
                //                                                                 return (
                //                                                                     null
                //                                                                 );
                //                                                             }
                //                                                             else {
                //                                                                 return (
                //                                                                     <Dropdown.Item href={crumb.path}>{crumb.name}</Dropdown.Item>
                //                                                                 );
                //                                                             }

                //                                                         })
                //                                                     }
                //                                                 </div>
                //                                             </Dropdown.Menu>
                //                                         </Dropdown>

                //                                     </Breadcrumb.Item>
                //                             }
                //                         </>

                //                         <Breadcrumb.Item active className={isOverflow == true ? "overflow-active" : ""}>
                //                             <span>{crumbs[crumbs.length - 1].name}</span>
                //                         </Breadcrumb.Item>

                //                     </>
                //                     :
                //                     crumbs.map((crumb, index) => {
                //                         //console.log(crumb);

                //                         if (index == crumbs.length - 1) {
                //                             return (
                //                                 <Breadcrumb.Item active >
                //                                     {crumb.name}
                //                                 </Breadcrumb.Item>
                //                             );
                //                         }
                //                         else {
                //                             if (index == 0) {
                //                                 return (
                //                                     <Breadcrumb.Item
                //                                         linkAs={Link}
                //                                         linkProps={{ to: crumb.path }}
                //                                         className=""
                //                                     >
                //                                         {crumb.name}
                //                                     </Breadcrumb.Item>
                //                                 );
                //                             }
                //                             else {
                //                                 return (
                //                                     <Breadcrumb.Item
                //                                         linkAs={Link}
                //                                         linkProps={{ to: crumb.path }}
                //                                         className=""
                //                                     >
                //                                         {crumb.name}
                //                                     </Breadcrumb.Item>
                //                                 );
                //                             }

                //                         }
                //                     })
                //             }
                //         </Breadcrumb>
                //     </div>
                // : null
    );
}

export default Breadcrumbs;